import 'vite/modulepreload-polyfill';
import './styles.js';
import {loaderReady} from './vendors.js';

await loaderReady;
await import('../vendors/vue.assets.js');
const {default: boot} = await import('../vendors/vue.bootstrap.js');
await import('./dependencies.js');
await import('../vendors/bs4.js');
await import('../vendors/waves.js');
const {default: register} = await import('./registrations.js');
register();
boot();
window.addEventListener('vite:preloadError', ()=> {
	const target = window.app.router.history.pending?.fullPath;
	if (target && target != window.location.pathname + window.location.search + window.location.hash) window.location.assign(target);
});
